import React, { useState, useEffect, createContext } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import TodoAssignmentAlerts from './TodoAssignmentAlerts';

export const SidebarContext = createContext({ collapsed: false });

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Responsive handling
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 1024;
      setIsMobile(mobile);
      
      if (mobile) {
        setSidebarOpen(false);
        setSidebarCollapsed(false);
      } else {
        setSidebarOpen(true);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleMenuToggle = () => {
    setSidebarOpen((open) => !open);
  };

  const handleSidebarClose = () => {
    if (isMobile) {
      setSidebarOpen(false);
    }
  };

  const handleSidebarCollapse = (collapsed) => {
    if (!isMobile) {
      setSidebarCollapsed(collapsed);
    }
  };

  return (
    <SidebarContext.Provider value={{ collapsed: sidebarCollapsed }}>
      <div className="min-h-screen bg-gradient-to-br from-neutral-50 via-white to-neutral-100 flex">
        <Sidebar 
          isOpen={sidebarOpen} 
          onClose={handleSidebarClose} 
          onCollapse={handleSidebarCollapse}
          isMobile={isMobile}
        />
        <div className={`flex-1 transition-all duration-300 ease-out ${
          isMobile 
            ? 'ml-0' 
            : sidebarCollapsed 
              ? 'ml-20' 
              : 'ml-64'
        }`}>
          <Header onMenuToggle={handleMenuToggle} isMobile={isMobile} />
          <main className="w-full">
            <div className="w-full px-2 sm:px-4 lg:px-6"> {/* Responsive padding */}
              <div className="animate-fade-in-up">
                {children}
              </div>
            </div>
          </main>
          <TodoAssignmentAlerts />
        </div>
      </div>
    </SidebarContext.Provider>
  );
};

export default Layout; 